<template>
  <v-row align="center" justify="center" class="text-center fill-height">
    <div>
      <img src="../../assets/generic-error.png" alt="Error" class="mb-4" />
      <h1 class="headline primary--text">
        It seems that you have lost your bearings...
      </h1>
      <p class="subheading">
        Sorry, the page you are looking for doesn't exist
        <br />
        Try to start from the
        <router-link to="/">home page</router-link> ;)
      </p>
    </div>
  </v-row>
</template>

<script>
export default {
  name: 'PageNotFoundError'
}
</script>

<style lang="scss" scoped>
img {
  max-width: 80%;
}
</style>
